import React from 'react';
import { createRoot } from 'react-dom/client';
import './deck.css';
import './app.css';
import './theme.css';
import './skin.css';
import App from './App';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
